import { BOTONES } from '../../../../../../../../componentes/botones';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/** Un dato de la ocurrencia, dentro del panel desplegado. */
export interface DetalleCategoria {
  label: string;
  valor: string;
  icono?: string;
}

/** Una ocurrencia de la categoría: una parada, un exceso, un evento, un paso por una zona. */
export interface ItemCategoria<T = unknown> {
  /** Clave estable para el @for. */
  id: string;
  titulo: string;
  /** Dato corto que se lee sin desplegar (velocidad, duración, estado). */
  descripcion?: string;
  colorDescripcion?: string;
  detalles?: DetalleCategoria[];
  /** Texto libre al pie, cuando hay (dirección). */
  nota?: string;
  /** Resaltada porque está seleccionada en el mapa. */
  seleccionado?: boolean;
  /** El objeto de dominio, para devolverlo en el evento. */
  dato?: T;
}

/**
 * Una categoría de resultados del viaje: paradas, excesos de velocidad, eventos
 * o zonas visitadas.
 *
 * Las cuatro tienen la misma forma —un panel por categoría, adentro un panel por
 * ocurrencia con sus datos y el botón que lleva al mapa—, así que la estructura
 * y el estilo viven acá una sola vez. Cada búsqueda mapea sus objetos a
 * `ItemCategoria` y no repite el armazón.
 *
 * Presentacional: no busca, no filtra y no conoce el estado del mapa.
 */
@Component({
  selector: 'app-lista-categoria',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    BOTONES,
    MatProgressSpinnerModule,
  ],
  templateUrl: './lista-categoria.component.html',
  styleUrl: './lista-categoria.component.scss',
})
export class ListaCategoriaComponent {
  @Input() titulo = '';
  @Input() items: ItemCategoria[] = [];

  /**
   * Color de la referencia al mapa. Sin `icono` se dibuja el mismo punto que
   * usa el marker; con `icono`, un mat-icon de ese color (las zonas se pintan
   * con el color propio de cada ubicación, así que no tienen un punto único).
   */
  @Input() color = '#29b6f6';
  @Input() icono?: string;

  /** Umbral con el que se contó la categoría: "≥3 min", "≥85 km/h". */
  @Input() umbral?: string;

  /** Se está calculando: la cabecera muestra spinner en lugar del total. */
  @Input() cargando = false;

  @Input() textoVacio = 'Sin datos';

  /** El total que va en la cabecera. Por defecto, los items que se muestran. */
  @Input() set contador(value: number | undefined) {
    this._contador = value;
  }
  get contador(): number {
    return this._contador ?? this.items.length;
  }
  private _contador?: number;

  @Output() verEnMapa = new EventEmitter<ItemCategoria>();

  /** Desplegar sólo muestra el detalle: al mapa se va con el botón. */
  public onVerEnMapa(item: ItemCategoria): void {
    this.verEnMapa.emit(item);
  }
}
